import React from "react";
import { MenusProvider } from "./context/menus-context";
import { Menus } from "./menus";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

const MenusFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Menus"}>
            <MenusProvider>
                <Menus />
            </MenusProvider >
        </BaseInternalFormFactory>

    );
};

export default MenusFactory;
